export default __webpack_public_path__ + "static/media/Clinical-Documents.383208be.svg";